import { CurrentContext } from '~/models';
import { version as appversion } from '~/package.json';
import SHA256 from 'crypto-js/sha256';
import Hex from 'crypto-js/enc-hex';

const userTypeMappings = [
	{ id: 'standard', value: 'Super' },
	{ id: 'operator', value: 'Standard' },
	{ id: 'external', value: 'External' },
];

export function identifyWithGainsight(currentContext: CurrentContext): void {
	if (!currentContext || !(window as any).aptrinsic) return;

	const user = currentContext.current_user;
	const org = currentContext.current_organisation;

	const lowerEmail = (user.email || '').toLowerCase();
	const uniqueUserId = SHA256(lowerEmail).toString(Hex);

	const userTypeMapping = userTypeMappings.find(mapping => mapping.id === user.user_type);
	const hasSuperpowers =
		user.can_create_projects ||
		user.can_export ||
		user.can_manage_all_projects ||
		user.can_manage_companies ||
		user.can_manage_insights ||
		user.can_manage_organisation ||
		user.can_manage_templates ||
		user.can_manage_users ||
		user.can_view_diagnostics ||
		user.can_edit_managed_templates;

	let userrole = userTypeMapping ? userTypeMapping.value : 'Unknown';
	userrole = userrole === 'Super' && hasSuperpowers ? 'Admin' : userrole;
	const userlicensetype = userrole;

	let userauthmethod: string | null = null;
	try {
		userauthmethod = sessionStorage.getItem('auth_method') || 'SSO';
	} catch {}

	const host = window.location.hostname;
	const customerId = host.split('.')[0];
	const countryCode = host.split('.')[1];
	const accountId = `damstraforms-${customerId}.${countryCode}`;
	const accountName = org.name;

	(window as any).aptrinsic('identify',
		{
			id: uniqueUserId,
			appversion,
			userlicensetype,
			userrole,
			userauthmethod,
			email: lowerEmail,
		},
		{
			id: accountId,
			name: accountName,
		}
	);
} 